import { classMap } from 'lit/directives/class-map.js';
import { ContextConsumer } from '@lit-labs/context';
import { html, nothing } from 'lit';

import fieldContext from './field.context';
import styles from './field-label.styles';
import { Component } from '../component';
import type { FieldSize } from './field.types';

export interface FieldLabelProps extends HTMLElement {
	size?: FieldSize;
	required?: boolean;
}

export class FieldLabel extends Component {
	static override styles = [styles()];

	static override get properties() {
		return {
			required: { type: Boolean },
			size: { type: String },
			slot: { type: String },
		};
	}

	/**
	 * Is this field required.
	 */
	declare required: FieldLabelProps['required'];

	/**
	 * Field size.
	 */
	declare size: FieldLabelProps['size'];

	declare slot: string;

	private field = new ContextConsumer(this, fieldContext, undefined, true);

	constructor() {
		super();

		this.slot = 'hint';
	}

	override render() {
		return html`<label
			class=${classMap({
				label: true,
				'-size-default': this.#getSize() === 'default',
				'-size-small': this.#getSize() === 'small',
			})}
			><slot></slot>
			${this.#isRequired() ? html`<span class="required">*</span>` : nothing}
		</label>`;
	}

	#getSize() {
		return this.size || this.field.value?.size;
	}

	#isRequired() {
		if (this.required != null) {
			return this.required;
		}

		return Boolean(this.field.value?.required);
	}
}

window.customElements.define('m-field-label', FieldLabel);

declare global {
	interface HTMLElementTagNameMap {
		'm-field-label': FieldLabel;
	}
}
